const setOrganisation = (context, data) => {
  context.commit("SET_ORGANISATION", data)
}

export default {
  setOrganisation
}
